import React from "react";
import { Transition } from "react-transition-group";
import Lottie from "react-lottie";
import cx from "clsx";
import { isTablet } from "react-device-detect";

import TextFromBottom from "@/components/shared/text/textFromBottom";
import HandSvg from "@/images/tour/hand.svg";

import tourStyles from "@/components/tour/tour.module.scss";
import globalStyles from "@/styles/global.module.scss";
import vars from "@/styles/_variables.scss";
import introStyles from "./intro.module.scss";
import styles from "./desktop-tourIntro.module.scss";

const ANIMATION_DELAY = 330;

const INTRO_LOTTIE_OPTIONS = {
  loop: true,
  autoplay: false,
  animationData: require("@/assets/lottie/desktop-intro.json"),
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};
const MOUSE_LOTTIE_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: require("@/assets/lottie/mouse-icon.json"),
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

class DesktopTourIntro extends React.PureComponent {
  state = {
    hasMounted: false,
    introHeight: 0,
    animationComplete: false
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { isDesktop, windowHeight } = nextProps;
    const { hasMounted } = prevState;

    let introHeight = isDesktop
      ? windowHeight
      : windowHeight -
        parseInt(vars.navbarMobileHeight) -
        parseInt(vars.tourBottomHeight);

    if (!hasMounted) introHeight = 0;

    return {
      ...prevState,
      introHeight
    };
  }

  componentDidMount() {
    setTimeout(() => this.setState({ hasMounted: true }), ANIMATION_DELAY);
  }

  handleIntroLottieComplete = () => this.setState({ animationComplete: true });

  renderBeginAnimation = () => {
    const { stopIndex, tourReady } = this.props;

    return (
      <Transition enter exit in={tourReady && stopIndex === 0} timeout={0}>
        {state => (
          <div
            className={cx(
              tourStyles.continueContainer,
              tourStyles.isDesktop,
              globalStyles.opacityAnimation,
              globalStyles[state]
            )}
          >
            {isTablet ? (
              <div
                className={cx(
                  tourStyles.handContainer,
                  tourStyles.handAnimation,
                  tourStyles.entered
                )}
              >
                <HandSvg alt="Hand" />
              </div>
            ) : (
              <Lottie options={MOUSE_LOTTIE_OPTIONS} width={24} height={80} />
            )}

            <div className={tourStyles.continueText}>
              {`${isTablet ? "SWIPE" : "SCROLL"}`} TO BEGIN
            </div>
          </div>
        )}
      </Transition>
    );
  };

  renderIntro = () => {
    const { isDesktop, tourReady, stopIndex } = this.props;
    const { hasMounted } = this.state;

    const title = isDesktop
      ? ["DESTINATION: INNOVATION"]
      : ["DESTINATION:", "INNOVATION"];

    return (
      <div
        className={cx(
          introStyles.logoContainer,
          !hasMounted && introStyles.hidden
        )}
      >
        <div
          className={cx(
            styles.loadingContainer,
            hasMounted && styles.visible,
            tourReady && styles.complete
          )}
        >
          <div className={cx(introStyles.introImg, styles.introImg)}>
            <Lottie
              options={INTRO_LOTTIE_OPTIONS}
              isPaused={!hasMounted}
              isStopped={tourReady}
              eventListeners={[
                {
                  eventName: "complete",
                  callback: this.handleIntroLottieComplete
                }
              ]}
            />
          </div>
        </div>
        <div className={styles.hiddenImg} />
        <h1 className={introStyles.mainText}>
          {title.map((t, index) => (
            <TextFromBottom
              key={`intro-title-${index}`}
              visible={tourReady && stopIndex < 1 ? true : false}
              delayMs={280 * (index + 1)}
              className={styles.textAnim}
              customAnimation={state => styles[state]}
            >
              {t}
            </TextFromBottom>
          ))}
        </h1>
        <div
          className={cx(
            introStyles.topSubtext,
            styles.delayTwo,
            globalStyles.opacityAnimation,
            tourReady && globalStyles.entered
          )}
          style={{ transitionDelay: `${330 + title.length * 280}ms` }}
        >
          The Peninsula’s Newest Innovation Hub in Downtown Redwood City
        </div>

        {isDesktop && tourReady ? this.renderBeginAnimation() : null}
      </div>
    );
  };

  render() {
    const { containerClassName } = this.props;
    const { introHeight } = this.state;

    return (
      <div
        className={cx(introStyles.container, containerClassName)}
        style={{ height: introHeight }}
      >
        <div className={introStyles.inner}>{this.renderIntro()}</div>
      </div>
    );
  }
}

export default DesktopTourIntro;
